import { isPlainObject } from "@suse-o11y/is-plain-object";
import type { Record } from "@suse-o11y/record";

export function hasProperty<TObject, TKey extends PropertyKey>(
	obj: TObject,
	key: TKey,
): obj is TObject & Record<TKey, unknown, "writable"> {
	return isPlainObject(obj) && key in obj;
}
